import { ProductOption } from "@Types/cart";

const optionsNotUpsells = [
  "additional_packs",
  "additional_pages",
  "additionnal_pages",
  "additional_photos",
  "format",
  "paper_type",
  "polabox_box",
];
const productsWithoutUpsell = ["gift"];
export const specialOptionsTags: { [key: string]: string } = {
  "box-20x20": "box",
  "box-28x28": "box",
};

export const getUpsellsToDisplay = (productOptions: ProductOption[]): ProductOption[] =>
  productOptions.filter((option) => !optionsNotUpsells.includes(option.productOptionTag));

export const hasProductUpsells = (tag: string): boolean => !productsWithoutUpsell.includes(tag);
